import { render, staticRenderFns } from "./studyReport.vue?vue&type=template&id=2477462e&scoped=true&"
import script from "./studyReport.vue?vue&type=script&lang=js&"
export * from "./studyReport.vue?vue&type=script&lang=js&"
import style0 from "./studyReport.vue?vue&type=style&index=0&id=2477462e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2477462e",
  null
  
)

export default component.exports